import React from 'react';
import { XIcon } from 'lucide-react';
import { disciplines, jobTypes, remoteOptions, Discipline, JobType } from '../../lib/data';
export interface Filters {
  disciplines: Discipline[];
  types: JobType[];
  remote: string[];
}
interface JobFiltersProps {
  filters: Filters;
  onChange: (f: Filters) => void;
  onClear: () => void;
}
export function JobFilters({
  filters,
  onChange,
  onClear
}: JobFiltersProps) {
  const toggle = <K extends keyof Filters,>(key: K, value: string) => {
    const list = filters[key] as string[];
    const next = list.includes(value) ? list.filter(v => v !== value) : [...list, value];
    onChange({
      ...filters,
      [key]: next
    });
  };
  const hasFilters = filters.disciplines.length + filters.types.length + filters.remote.length > 0;
  return <div className="rounded-2xl border border-ink/10 bg-ivory-50 p-6 shadow-soft" data-id="element-207" data-mp="2tpiwht6yrow">
      <div className="flex items-center justify-between" data-id="element-208" data-mp="7tc6nl6nbqby">
        <h2 className="font-serif text-lg text-ink" data-id="element-209" data-mp="7ssqoa0k3c0k">Refine</h2>
        {hasFilters && <button onClick={onClear} className="inline-flex items-center gap-1 text-xs text-ink-500 transition-colors hover:text-gold-dark" data-id="element-210" data-mp="23xibjq7ttlww">
            <XIcon className="h-3 w-3" data-id="element-211" data-mp="2dx9960rooh17" /> Clear
          </button>}
      </div>

      <FilterGroup title="Discipline" data-id="element-212" data-mp="28xeinybtltgo">
        {disciplines.map(d => <CheckRow key={d} label={d} checked={filters.disciplines.includes(d)} onChange={() => toggle('disciplines', d)} data-id="element-213" data-mp="28w3h855ukxsq" />)}
      </FilterGroup>

      <FilterGroup title="Engagement" data-id="element-214" data-mp="1uxvax6mx8k4w">
        {jobTypes.map(t => <CheckRow key={t} label={t} checked={filters.types.includes(t)} onChange={() => toggle('types', t)} data-id="element-215" data-mp="1v0846fy4qgx9" />)}
      </FilterGroup>

      <FilterGroup title="Location" last data-id="element-216" data-mp="12frbnj0p4dn4">
        {remoteOptions.map(r => <CheckRow key={r} label={r} checked={filters.remote.includes(r)} onChange={() => toggle('remote', r)} data-id="element-217" data-mp="xi7ykmfqi6wr" />)}
      </FilterGroup>
    </div>;
}
function FilterGroup({
  title,
  children,
  last
}: {
  title: string;
  children: React.ReactNode;
  last?: boolean;
}) {
  return <div className={`mt-6 ${last ? '' : 'border-b border-ink/10 pb-6'}`} data-id="element-218" data-mp="3bc5jia16mrv3">
      <h3 className="text-xs font-medium uppercase tracking-widest2 text-ink-500" data-id="element-219" data-mp="3be88qruiggyr">
        {title}
      </h3>
      <div className="mt-3 space-y-1" data-id="element-220" data-mp="2jl7xfotbm5il">{children}</div>
    </div>;
}
function CheckRow({
  label,
  checked,
  onChange
}: {
  label: string;
  checked: boolean;
  onChange: () => void;
}) {
  return <label className="flex cursor-pointer items-center gap-3 rounded-lg py-1.5 text-sm text-ink-600 transition-colors hover:text-ink" data-id="element-221" data-mp="2slw6s67rrhp5">
      <span className={`flex h-4 w-4 items-center justify-center rounded border transition-colors ${checked ? 'border-gold bg-gold' : 'border-ink/25 bg-transparent'}`} data-id="element-222" data-mp="2vkait8jvyrz">
        {checked && <svg viewBox="0 0 12 12" className="h-3 w-3 text-ink" aria-hidden="true" data-id="element-223" data-mp="hyu1579xmss9">
            <path d="M2.5 6.2l2.2 2.2 4.6-4.8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" data-id="element-224" data-mp="d12byl0o9krr" />
          </svg>}
      </span>
      <input type="checkbox" checked={checked} onChange={onChange} className="sr-only" data-id="element-225" data-mp="3vfjly0sj1sf9" />
      {label}
    </label>;
}